// extracted by mini-css-extract-plugin
export default {"tableStyles":"TotalEnergyMediumTable_tableStyles__07JUU","summaryCellStyle":"TotalEnergyMediumTable_summaryCellStyle__mBIN7"};